import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';

import type { ProjectDatabaseId } from 'data/v1';
import type {
  V3ApiSuccessfulResponse,
  V3ApiFailedResponse,
} from 'javascripts/services/v3ApiClient';

export type GetShowcaseProjectProjectTypesResponse = V3ApiSuccessfulResponse<{
  projectTypes: string[];
}>;

export const SHOWCASE_PROJECT_PROJECT_TYPES_QUERY_KEY =
  'ShowcaseProjectProjectTypes';

export const useGetShowcaseProjectProjectTypes = (
  projectDatabaseId: ProjectDatabaseId,
) => {
  return useQuery<GetShowcaseProjectProjectTypesResponse, V3ApiFailedResponse>({
    queryFn: () => {
      return request({
        url: `projects/${projectDatabaseId}/showcase_project/project_types`,
      });
    },
    queryKey: [SHOWCASE_PROJECT_PROJECT_TYPES_QUERY_KEY, projectDatabaseId],
  });
};
